import { ReactNode, useEffect, useRef } from "react"
import { usePage } from "@inertiajs/react"
import { toast } from "sonner"
import { Toaster } from "@/components/ui/sonner"
import { ErrorBoundary } from "@/components/error-boundary"
import { Footer } from "@/components/footer"
import type { SharedProps } from "@/types"

type Props = {
  children: ReactNode
}

export function Layout({ children }: Props) {
  const { flash } = usePage<SharedProps>().props
  const shownRef = useRef<{ notice?: string | null; alert?: string | null }>({})

  useEffect(() => {
    // Show notice toast if it changed
    if (flash.notice && flash.notice !== shownRef.current.notice) {
      toast.success(flash.notice)
      shownRef.current.notice = flash.notice
    }

    // Show alert toast if it changed
    if (flash.alert && flash.alert !== shownRef.current.alert) {
      toast.error(flash.alert)
      shownRef.current.alert = flash.alert
    }
  }, [flash.notice, flash.alert])

  return (
    <ErrorBoundary>
      <div className="min-h-screen flex flex-col vignette">
        <div className="flex-1 grain">{children}</div>
        <Footer />
      </div>
      <Toaster position="bottom-right" />
    </ErrorBoundary>
  )
}
